module.exports = __webpack_public_path__ + "img/empty-state-horn.f59d064e.png";